import { useCallback, useState } from 'react';
import useAbortableEffect from '../../../../../../Hooks/useAbortableEffect';
import { getTiktokAudioDailyStats, TiktokAudioDailyStats } from '@round/api';

export default function useTiktokAudioCreationsStats(audioId: number | undefined) {
    const [creationsStats, setCreationsStats] = useState<TiktokAudioDailyStats[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [errorLoading, setErrorLoading] = useState(false);

    const fetchStats = useCallback(
        async (requestInit?: RequestInit) => {
            if (!audioId) {
                return;
            }

            try {
                setErrorLoading(false);
                setIsLoading(true);
                const {
                    data: { results: stats },
                } = await getTiktokAudioDailyStats(audioId, requestInit);
                setCreationsStats(stats);
            } catch (e) {
                if (e instanceof Error && e.name === 'AbortError') {
                    return;
                }

                setErrorLoading(true);
            } finally {
                setIsLoading(false);
            }
        },
        [audioId]
    );

    const abortController = useAbortableEffect(
        (signal) => {
            fetchStats({ signal });
        },
        [fetchStats]
    );

    const reset = useCallback(() => {
        setCreationsStats([]);
        setIsLoading(false);
        setErrorLoading(false);
    }, []);

    return {
        creationsStats,
        isLoading,
        errorLoading,
        refresh: fetchStats,
        abortController,
        reset,
    };
}
